import React from 'react';
import { ActionIcon, Indicator, Tooltip } from '@mantine/core';
import { IconStopwatch } from '@tabler/icons-react';
import { useRequestTrackingModal } from '../../contexts/RequestTrackingModalContext';

function formatBadgeLabel(count: number): string {
  if (count > 99) {
    return '99+';
  }
  return String(count);
}

/** Always available — not gated by resource permissions. */
export function RequestTrackerToggle() {
  const { openRequestTracker, opened, activeRequestCount, refreshActiveRequestCount } =
    useRequestTrackingModal();

  const showBadge = activeRequestCount > 0;
  const tooltipLabel = showBadge
    ? `Request tracker (${activeRequestCount} active)`
    : 'Request tracker';

  return (
    <Tooltip label={tooltipLabel} withArrow>
      <Indicator
        label={formatBadgeLabel(activeRequestCount)}
        size={16}
        color="blue"
        offset={4}
        disabled={!showBadge}
        processing={showBadge}
      >
        <ActionIcon
          variant={opened ? 'light' : 'subtle'}
          color={opened ? 'brand' : 'gray'}
          size="md"
          aria-label={tooltipLabel}
          aria-pressed={opened}
          onMouseEnter={() => refreshActiveRequestCount()}
          onFocus={() => refreshActiveRequestCount()}
          onClick={() => openRequestTracker()}
        >
          <IconStopwatch size={20} stroke={1.5} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  );
}
